document.addEventListener("alpine:initialized", function () {
  let askModelBtn = document.querySelector("#askModelBtn");
  let askModelCloseBtn = document.getElementById("closeModalBtn");
  let askModel = document.getElementById("customAskModal");
  let askModelBackdrop = document.getElementById("modalBackdrop");
  if (askModelBtn) {
    askModelBtn.onclick = function () {
      askModel.classList.add("show");
      askModel.style.display = "block";
      askModelBackdrop.classList.add("show");
      askModelBackdrop.style.display = "block";
    };
  }
  if (askModelCloseBtn) {
    askModelCloseBtn.onclick = function () {
      askModel.classList.remove("show");
      askModel.style.display = "none";
      askModelBackdrop.classList.remove("show");
      askModelBackdrop.style.display = "none";
    };
  }
  if (askModelBackdrop) {
    askModelBackdrop.onclick = function () {
      askModelCloseBtn.click();
    };
  }
});
